import { Link } from 'react-router-dom'
import Screen from '../components/ui/Screen'
import Panel from '../components/ui/Panel'
import { buttonClasses } from '../components/ui/Button'
import texts from '../texts'

function Landing() {
  return (
    <Screen bare>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="grid h-[30px] w-[30px] place-items-center rounded-[9px] bg-[#f5c451] font-extrabold text-ink">
            W
          </span>
          <b className="font-display">{texts.landing.brand}</b>
        </div>
        <Link to="/login" className={buttonClasses({ variant: 'ghost', size: 'sm' })}>
          {texts.landing.logIn}
        </Link>
      </div>

      <div className="relative h-[120px]">
        <div className="absolute bottom-0 left-1/2 flex aspect-[5/7] w-[62px] origin-[50%_130%] items-center justify-center rounded-[7px] bg-cream font-display text-[26px] font-extrabold text-ink shadow-[0_8px_18px_rgba(0,0,0,.35)] [transform:translateX(-50%)_rotate(-18deg)_translateX(-44px)]">
          ♠
        </div>
        <div className="absolute bottom-0 left-1/2 flex aspect-[5/7] w-[62px] origin-[50%_130%] items-center justify-center rounded-[7px] bg-cream font-display text-[26px] font-extrabold text-[#e5323e] shadow-[0_8px_18px_rgba(0,0,0,.35)] [transform:translateX(-50%)]">
          ♥
        </div>
        <div className="absolute bottom-0 left-1/2 flex aspect-[5/7] w-[62px] origin-[50%_130%] items-center justify-center rounded-[7px] bg-cream font-display text-[26px] font-extrabold text-ink shadow-[0_8px_18px_rgba(0,0,0,.35)] [transform:translateX(-50%)_rotate(18deg)_translateX(44px)]">
          ♣
        </div>
      </div>

      <div className="grid gap-2.5">
        <h1 className="text-[2.4rem] tracking-[-.02em] text-cream">
          Whistaftenen uden <em className="font-normal text-gold">regnestykker.</em>
        </h1>
        <p className="text-text-2">{texts.landing.intro}</p>
      </div>

      <Link to="/login" className={buttonClasses({ full: true })}>
        {texts.landing.start}
      </Link>
      <Link to="/regler" className={buttonClasses({ variant: 'ghost', full: true })}>
        {texts.landing.seeRules}
      </Link>

      <Panel>
        <div className="grid grid-cols-[32px_1fr] items-start gap-2.5">
          <span className="text-[22px] leading-none">♠</span>
          <div>
            <b className="block font-display">{texts.landing.feature1Title}</b>
            <span className="text-[0.85em] text-text-2">{texts.landing.feature1Text}</span>
          </div>
        </div>
        <div className="grid grid-cols-[32px_1fr] items-start gap-2.5">
          <span className="text-[22px] leading-none text-red">♥</span>
          <div>
            <b className="block font-display">{texts.landing.feature2Title}</b>
            <span className="text-[0.85em] text-text-2">{texts.landing.feature2Text}</span>
          </div>
        </div>
        <div className="grid grid-cols-[32px_1fr] items-start gap-2.5">
          <span className="text-[22px] leading-none text-red">♦</span>
          <div>
            <b className="block font-display">{texts.landing.feature3Title}</b>
            <span className="text-[0.85em] text-text-2">{texts.landing.feature3Text}</span>
          </div>
        </div>
      </Panel>

      <p className="text-center text-[0.85em] text-text-2">
        {texts.landing.footerFree} · {texts.landing.footerBy}
        <br />
        <Link to="/privatliv" className="text-text-2">
          {texts.landing.footerPrivacy}
        </Link>
      </p>
    </Screen>
  )
}

export default Landing
